"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    AnnotationQuestion: function() {
        return AnnotationQuestion;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const AnnotationQuestion = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M2 5C2 3.34315 3.34315 2 5 2H19C20.6569 2 22 3.34315 22 5V17C22 18.6569 20.6569 20 19 20H15.7552L12.6644 22.7474C12.2855 23.0842 11.7145 23.0842 11.3356 22.7474L8.2448 20H5C3.34315 20 2 18.6569 2 17V5ZM5 4C4.44772 4 4 4.44772 4 5V17C4 17.5523 4.44772 18 5 18H8.2448C8.73463 18 9.20743 18.1798 9.57353 18.5052L12 20.662L14.4265 18.5052C14.7926 18.1798 15.2654 18 15.7552 18H19C19.5523 18 20 17.5523 20 17V5C20 4.44772 19.5523 4 19 4H5ZM11.9564 8C11.1337 8 10.44 8.56264 10.2436 9.32561C10.1059 9.86047 9.56074 10.1825 9.02589 10.0448C8.49103 9.90713 8.16905 9.36195 8.30671 8.8271C8.725 7.20194 10.1991 6 11.9564 6C14.0377 6 15.7249 7.6872 15.7249 9.76847C15.7249 10.8994 15.1864 11.6577 14.5733 12.2541C14.3129 12.5074 14.0161 12.7535 13.7374 12.9845C13.7055 13.0109 13.6739 13.0371 13.6426 13.0631C13.3253 13.3267 13.0123 13.5915 12.7027 13.8973C12.3097 14.2854 11.6766 14.2814 11.2885 13.8884C10.9004 13.4955 10.9044 12.8623 11.2973 12.4742C11.6725 12.1037 12.0425 11.7923 12.3645 11.5248C12.3947 11.4997 12.4243 11.4751 12.4534 11.451C12.7454 11.2087 12.9788 11.015 13.1787 10.8205C13.5857 10.4246 13.7249 10.1505 13.7249 9.76847C13.7249 8.79177 12.9331 8 11.9564 8ZM10.97 17C10.97 16.4477 11.4177 16 11.97 16H11.98C12.5323 16 12.98 16.4477 12.98 17C12.98 17.5523 12.5323 18 11.98 18H11.97C11.4177 18 10.97 17.5523 10.97 17Z",
        fill: "currentColor"
    })
}), "AnnotationQuestion");
const _default = AnnotationQuestion;
